/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { APP_CONFIG as CORE_APP_CONFIG } from '@core/config/app-config';
import { AppConfigModel } from '@models/app/app-config.model';
import { RouteCodes } from '@core/config/route-codes';
import { EditableParam } from '@core/models/quotation-calculate';

export const APP_CONFIG: AppConfigModel = {
  ...CORE_APP_CONFIG,
  generic: {
    ...CORE_APP_CONFIG.generic,
    errorDisplay: 'complete',
    errorsWithRedirect: {
      'exception.que.assi.negative.answer': RouteCodes.reservedArea,
      'exception.task.close.error': RouteCodes.position
    },
    sendLogs: true
  },
  theme: { logoUrl: 'assets/icons/logo_banca.svg' },
  security: {
    ...CORE_APP_CONFIG.security,
    authCodeRequired: false,
    logoutEnabled: false
  },
  labels: {
    ...CORE_APP_CONFIG.labels,
    filter: { key: 'ct', value: 'WEBAPP' }
  },
  wizard: {
    ...CORE_APP_CONFIG.wizard,
    startPage: 'first-open-step',
    closingMode: 'workflow',
    nextPage: 'first-open-step',
    avoidBack: true,
    freeNavigation: false,
    dummyWizards: {
      ['POST_VENIDTA_SVINCOLO_TFR']: {
        wizardCode: 'PV-TFR-REL',
        status: 0,
        steps: [
          {
            stepCode: 'WEB-STAMP-CONTR-TFR',
            status: 0
          }
        ]
      },
      ['POST_VENIDTA_RECESSO']: {
        wizardCode: 'PV-WITHDRAW',
        status: 0,
        steps: []
      }
    },
    themes: {
      ['POST_VENIDTA_SVINCOLO_TFR']: 'after-sales',
      ['POST_VENIDTA_RECESSO']: 'after-sales'
    }
  },
  upload: {
    ...CORE_APP_CONFIG.upload,
    documentPages: {
      ['B03.1']: 'front|back',
      ['B03.3']: 'front|back',
      ['B04']: 'front|back'
    },
    additionalPages: {
      ['F22']: 20,
      ['B05']: 20,
      ['B07']: 20,
      ['B94']: 20,
      ['B09']: 20,
      ['B95']: 20,
      ['F06']: 20
    },
    pageHints: true,
    avoidInstructions: true,
    gridOnPreview: true
  },
  form: {
    ...CORE_APP_CONFIG.form,
    stepCodeAsCode: true,
    fixedCol: true
  },
  survey: {
    ...CORE_APP_CONFIG.survey,
    alertWhenContinue: true,
    stepCodeAsCode: true,
    fixedCol: true
  },
  quotation: {
    primaryData: [
      {
        id: 'nettoErogatoCqs',
        title: 'lbl.quotation_upright',
        format: 'currency'
      },
      {
        id: 'rata',
        title: 'lbl.quotation_installment',
        format: 'currency'
      },
      {
        id: 'durata',
        title: 'lbl.quotation_duration',
        format: 'month'
      },
      { id: 'tan', title: 'lbl.quotation_tan', format: 'perc' },
      { id: 'taeg', title: 'lbl.quotation_taeg', format: 'perc', bold: true },
      {
        id: 'nettoErogatoCqs',
        title: 'lbl.quotation_cqs_net_disbursed',
        format: 'currency'
      },
      {
        id: 'montante',
        title: 'lbl.quotation_theoretical_total_amount',
        format: 'currency'
      },
      {
        id: 'interessi',
        title: 'lbl.quotation_interests',
        format: 'currency'
      }
    ],
    secondaryData: [],
    editableParams: [EditableParam.instalment],
    rejectAllowed: true,
    view: 'step-by-step',
    moduleCodes: ['comm-offer', 'pre-contr', 'pre-contr-insurance'],
    moduleCodesToMark: ['comm-offer', 'pre-contr', 'pre-contr-insurance'],
    moduleCodesToView: ['comm-offer', 'pre-contr', 'pre-contr-insurance']
  },
  quotationCalculate: {
    ...CORE_APP_CONFIG.quotationCalculate,
    preparationSections: [EditableParam.amount, EditableParam.duration],
    editableSections: [EditableParam.amount, EditableParam.duration],
    detailsInline: true
  },
  documentsRequest: {
    ...CORE_APP_CONFIG.documentsRequest,
    checkFormPrefix: 'SB_'
  },
  digitalSignature: {
    positionMustBe: [
      ['==100', 'DTA-RDY'],
      ['==100', 'RIC-RAG'],
      ['>100', null]
    ]
  }
};
